<template>
  <el-table-column
    prop="customer.name"
    sortable="custom"
    label="Átvevő"
    show-overflow-tooltip
    min-width="150"
  >
    <template slot-scope="scope">
      {{ scope.row.customer.name }}
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'customer.name',
};
</script>
